import { defineStore } from 'pinia';
import { setCookie, getCookie, isMobileView } from '@/utils';
import { ref, watch } from 'vue';
import { hideNavbarPaths } from '@/resources/constants';
import router from '@/router';
export const useSidebarStore = defineStore('useSidebarShrinkStore', () => {
  const cookieIsShrink = !!JSON.parse(`${getCookie('isShrink')}`);
  const isShrink = ref(cookieIsShrink || false);
  const isMobile = isMobileView();
  const showMenu = ref(false);

  function handleShrink(isLogout = false) {
    isShrink.value = !isShrink.value;
    setCookie('isShrink', String(isShrink.value));
    handleAppClassName(isLogout);
  }
  function handleAppClassName(isLogout = false) {
    const appContainerEl: HTMLDivElement | null = document.querySelector('#app');
    const className = isMobile ? 'margin-mobile' : 'margin-desktop';
    if (appContainerEl) {
      appContainerEl.classList.toggle('margin-shrink', isShrink.value);
      appContainerEl.classList.toggle(className, !isShrink.value);
      if (isLogout) {
        appContainerEl.classList.remove(className);
        appContainerEl.classList.remove('margin-shrink');
      }
    }
  }
  watch(() => router.currentRoute?.value?.name, (newRouteName) => {
    if (newRouteName) {
      showMenu.value = !hideNavbarPaths.includes(newRouteName?.toString() ?? '');
    }
  });
  return { isShrink, handleShrink, handleAppClassName, showMenu };
});
